import { render, staticRenderFns } from "./MintAgreementSummaryCard.vue?vue&type=template&id=0d521766"
import script from "./MintAgreementSummaryCard.vue?vue&type=script&lang=js"
export * from "./MintAgreementSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports